/*
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-12-01 11:50:33
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-12-01 11:51:20
 * @FilePath: \合联\oms\src\api\forecastManagement\overseasShelve.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/warehouse/shelf'

export const apis = buildApi({
  get: [name + '/index&list', name + '/exception/:id&exception'],
  post: [name + '/deal']
})